import * as React from "react";
import RequiredLabel from "./RequiredLabel";

interface IProps {
	className?: string;
	style?: {};
	children?: {};
	required?: boolean;
	htmlFor?: string;
}

const Label: React.FC<IProps> = (props) => {
	return (
		<label className={props.className} htmlFor={props.htmlFor}>
			{props.children && (
				<span
					className={`label-title${
						props.required ? " label-title-required" : ""
					}`}
				>
					{props.children}
				</span>
			)}
			{props.required && <RequiredLabel>Required</RequiredLabel>}
		</label>
	);
};

export default Label;
